import { Col, Row, Typography } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { Empty } from 'src/components/Empty/Empty';
import { ListPage } from 'src/components/FormPages/ListPage';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { MerchantDto } from 'src/generated-api-client';
import { MerchantsStore } from 'src/stores/MerchantsStore/MerchantsStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

export const MerchantsPage = observer(() => {
    return (
        <ListPage
            pageName="Merchants"
            store={MerchantsStore}
            header={
                <Row gutter={16}>
                    <Col flex={1}>
                        <Typography.Title level={3}>
                            {t('App.Pages.Merchants.Title')}
                        </Typography.Title>
                    </Col>
                </Row>
            }
            empty={<Empty description={t('App.Pages.Merchants.Empty')} />}
            renderItem={(item: Entity) => {
                const merchant = item as unknown as MerchantDto;

                return (
                    <Card
                        key={merchant.id}
                        onClick={() => {
                            const path =
                                merchant.id !== undefined
                                    ? EntityLinks.merchants.itemDetails?.(
                                          merchant.id,
                                      )
                                    : undefined;

                            if (path) {
                                Router.navigate(path);
                            }
                        }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col xs={12} sm={8} md={6}>
                                <DataView
                                    label={t('App.Pages.Merchants.Number')}
                                    value={merchant.number}
                                />
                            </Col>
                            <Col xs={12} sm={8} md={6}>
                                <DataView
                                    label={t(
                                        'App.Pages.Merchants.ExternalMerchantId',
                                    )}
                                    value={merchant?.externalMerchantId}
                                />
                            </Col>
                            <Col xs={12} sm={8} md={6}>
                                <DataView
                                    label={t('App.Pages.Merchants.Name')}
                                    value={merchant.name}
                                />
                            </Col>
                            <Col xs={12} sm={8} md={6}>
                                <DataView
                                    label={t('App.Pages.Merchants.CreatedAt')}
                                    value={merchant.createdAt}
                                    formatValue="dateTimeSeconds"
                                />
                            </Col>
                        </Row>
                    </Card>
                );
            }}
        />
    );
});
